import { useBryq } from './BryqContext';
import { chipLook } from './bryqLook';

/** The 🧠 Bryq chip, next to 📝 on every candidate card — see chipLook for its states. */
export function BryqChip({ candidateName, opportunityId }: { candidateName: string; opportunityId: string }) {
  const bryq = useBryq();
  if (!bryq) return null;
  const look = chipLook(bryq.statusFor(opportunityId));
  return (
    <button
      type="button"
      onClick={() => bryq.openBryq({ opportunityId, candidateName })}
      className="inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold hover:opacity-80"
      style={{ backgroundColor: look.bg, color: look.text }}
      title={look.title}
      aria-label={`Bryq for ${candidateName}: ${look.label.replace('🧠 ', '')}`}
    >
      {look.label}
    </button>
  );
}
